module.exports = __webpack_public_path__ + "static/img/bg-jgpt-case-tunnel.b4e1173d.png";